import * as React from "react";
import { WithStyles, withStyles, createStyles } from 'components/controls/styles';
import { MemberApplicationFormState } from "../entity";
import { isFormState, useApplication } from "../store";
import { Grid, Typography } from "components/controls/widget";
import { TextInput, PhoneInput, ZipCodeInput, Checkbox, DateInput } from "components/controls/formControls";
import { formInputProps } from "./definition";

const styles = () => createStyles({
    header1: {
        color: '#337ab7',
        fontSize: '1.1rem',
    },
    header2: {
        fontSize: '0.9rem',
    },
    note1: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    note2: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
});


const HomeAddress = withStyles(styles)(({ classes }: WithStyles<typeof styles>) => {
    let [state, actions] = useApplication();
    let showAddress = !isFormState(state, MemberApplicationFormState.LegalRepHomeAddressIsSameAsMember);

    return <Grid container direction="column" spacing={8}>
        <Grid item container alignItems="center">
            <Grid item>
                <Typography className={classes.header2} variant="subtitle1">{"Adresa bydliště zákonného zástupce"}</Typography>
            </Grid>
            <Grid item>
                <Checkbox {...formInputProps('legalRepHomeAddressIsSameAsMember', state, actions)} hideLabel />
            </Grid>
            <Grid>
                <span className={classes.note2}>{'zvolte pokud je jiná než adresa bydliště člena'}</span>
            </Grid>
        </Grid>
        {showAddress && <Grid container item spacing={16}>
            <Grid item sm={4}>
                <TextInput  {...formInputProps('legalRepresentative.homeAddress.street', state, actions)} />
            </Grid>
            <Grid item sm={3}>
                <TextInput {...formInputProps('legalRepresentative.homeAddress.city', state, actions)} />
            </Grid>
            <Grid item sm={2}>
                <ZipCodeInput {...formInputProps('legalRepresentative.homeAddress.zipCode', state, actions)} />
            </Grid>
            <Grid item sm={3}>
                <TextInput {...formInputProps('legalRepresentative.homeAddress.post', state, actions)} />
            </Grid>
        </Grid>}
    </Grid>;
});

const PostAddress = withStyles(styles)(({ classes }: WithStyles<typeof styles>) => {
    let [state, actions] = useApplication();

    let showAddress = !isFormState(state, MemberApplicationFormState.LegalRepPostAddressIsSameAsHome);

    return <Grid container direction="column" spacing={8}>
        <Grid item container alignItems="center">
            <Grid item>
                <Typography className={classes.header2} variant="subtitle1">{"Adresa pro korespondenci zákonného zástupce"}</Typography>
            </Grid>
            <Grid item>
                <Checkbox {...formInputProps('legalRepPostAddressIsSameAsHome', state, actions)} hideLabel />
            </Grid>
            <Grid>
                <span className={classes.note2}>{'zvolte pokud chcete poštu doručovat jinam než na adresu bydliště'}</span>
            </Grid>
        </Grid>
        {showAddress && <Grid container item spacing={16}>
            <Grid item sm={4}>
                <TextInput  {...formInputProps('legalRepresentative.postAddress.street', state, actions)} />
            </Grid>
            <Grid item sm={3}>
                <TextInput {...formInputProps('legalRepresentative.postAddress.city', state, actions)} />
            </Grid>
            <Grid item sm={2}>
                <ZipCodeInput {...formInputProps('legalRepresentative.postAddress.zipCode', state, actions)} />
            </Grid>
            <Grid item sm={3}>
                <TextInput {...formInputProps('legalRepresentative.postAddress.post', state, actions)} />
            </Grid>
        </Grid>}
    </Grid>;
})

const PersonalData = () => {
    let [state, actions] = useApplication();

    return <Grid container direction="row" spacing={32}>
        <Grid item>
            <Grid container direction="row" spacing={16}>
                <Grid item sm={5} >
                    <TextInput  {...formInputProps('legalRepresentative.surname', state, actions)} />
                </Grid>
                <Grid item sm={4} >
                    <TextInput {...formInputProps('legalRepresentative.name', state, actions)} />
                </Grid>
                <Grid item sm={3} >
                    <TextInput {...formInputProps('legalRepresentative.title', state, actions)} />
                </Grid>

                <Grid item sm={3} >
                    <DateInput {...formInputProps('legalRepresentative.birthDate', state, actions)} />
                </Grid>
                <Grid item sm={6} >
                    <TextInput  {...formInputProps('legalRepresentative.email', state, actions)} />
                </Grid>
                <Grid item sm={3} >
                    <PhoneInput {...formInputProps('legalRepresentative.mobilePhone', state, actions)} />
                </Grid>
            </Grid>
        </Grid>
    </Grid>;
}


const View = withStyles(styles)(({ classes }: WithStyles<typeof styles>) => {
    let [state, actions] = useApplication();
    const showLegalRepresentative = isFormState(state, MemberApplicationFormState.HasLegalRepresentative);

    return <Grid container direction="column" spacing={16}>
        <Grid item container alignItems="center">
            <Grid item>
                <Typography className={classes.header1} variant="h6">{"Zákonný zástupce člena"}</Typography>
            </Grid>
            <Grid item>
                <Checkbox {...formInputProps('hasLegalReprsentative', state, actions)} hideLabel />
            </Grid>
            <Grid item>
                <span className={classes.note1}>{'zvolte a vyplňte pokud je člen nezletilý'}</span>
            </Grid>
        </Grid>

        {showLegalRepresentative && <Grid item>
            <PersonalData />
        </Grid>}

        {showLegalRepresentative && <Grid item>
            <HomeAddress />
        </Grid>}

        {showLegalRepresentative && <Grid item>
            <PostAddress />
        </Grid>}

    </Grid>
});


export {
    View as LegalRepresentativeView,
}